// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function Footer() {
  const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  if (downSM) return null;

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        px: 1,
        py: 0,
        minHeight: 14,
        mt: 'auto'
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1 }}>
        &copy; {new Date().getFullYear()}{' '}
        <Link href="https://pixolab.in" target="_blank" rel="noopener" underline="hover">
          pixolab.in
        </Link>
      </Typography>
    </Stack>
  );
}
